const appConfig = {
  apiBaseUrl: "https://admin.bracetekk.com/api/",
  apiPrefix: "/api",
  imageBaseUrl: "https://admin.bracetekk.com/api/bucket/",
  authenticatedEntryPath: "/app/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/app/account/kyc-form",
  enableMock: true,
};




export default appConfig;
